<template>
  <div style="padding: 40px 0;">
    <p style="font-size: 16px;">正在跳转至支付页面，请稍候...</p>
    <p v-if="!applyResult" style="color: #f56c6c; margin-top: 10px;">跳转链接获取失败，请返回重新发起支付</p>
  </div>
</template>

<script>
export default {
  name: "redirect-pay",
  props: {
    applyResult: {
      type: String,
      default: ''
    }
  },
  watch: {
    applyResult(newValue) {
      this.redirect(newValue)
    }
  },
  mounted() {
    if (this.applyResult) {
      this.redirect(this.applyResult)
    }
  },
  methods: {
    redirect(url) {
      if (url) {
        window.location.href = url
      }
    }
  }
}
</script>
